import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  alertApiRef,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { ToastApiMessage, toastApiRef } from '@backstage/frontend-plugin-api';
import { isValidElement } from 'react';

const reactNodeToString = (
  node: React.ReactNode | null | undefined,
): string => {
  if (node === null || node === undefined) {
    return '';
  }
  if (typeof node === 'string') {
    return node;
  }
  if (Array.isArray(node)) {
    return node.map(reactNodeToString).join(' ');
  }
  if (isValidElement(node)) {
    return reactNodeToString(node.props.children);
  }
  return '';
};

const toastStatusToSeverity = (message: ToastApiMessage) => {
  const toastStatus = message.status ?? 'success';
  switch (toastStatus) {
    case 'warning':
      return 'warning';
    case 'danger':
      return 'error';
    default:
      return 'info';
  }
};

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // Workaround: app-defaults@1.7.8 registers no implementation for toastApiRef,
  // which plugin-notifications' NotificationsSidebarItem began consuming in
  // Backstage v1.49.0 (white screen: "No implementation available for
  // apiRef{core.toast}"). Mirrors the fix upstream shipped in
  // app-defaults@1.7.9 — remove once we bump past that stable release.
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => ({
      post(toast: ToastApiMessage) {
        alertApi.post({
          message: reactNodeToString(toast?.title),
          severity: toastStatusToSeverity(toast),
          display: 'transient',
        });
        return { close: () => {} };
      },
    }),
  }),
];
